export function formatIndianCompactNumber(value: unknown): string {
  const number = Number(value || 0);
  if (!Number.isFinite(number)) return '0';

  const absolute = Math.abs(number);
  let divisor = 1;
  let suffix = '';

  if (absolute >= 10_000_000) {
    divisor = 10_000_000;
    suffix = ' Crore';
  } else if (absolute >= 100_000) {
    divisor = 100_000;
    suffix = ' Lakh';
  }

  return new Intl.NumberFormat('en-IN', {
    maximumFractionDigits: suffix ? 1 : 0,
  }).format(number / divisor) + suffix;
}

export function formatIndianCompactCurrency(value: unknown): string {
  return `₹${formatIndianCompactNumber(value)}`;
}

export function parseIndianCompactNumber(value: string): number {
  const normalized = value.replace(/[₹,\s]/g, '').toLowerCase();
  const multiplier = normalized.endsWith('crore')
    ? 10_000_000
    : normalized.endsWith('lakh')
      ? 100_000
      : 1;
  const number = Number.parseFloat(normalized.replace(/crore|lakh/g, ''));
  return Number.isFinite(number) ? number * multiplier : 0;
}
